<span
  [class]="{
    'aur-badge': true,
    'autopay-on': isAutopayEnabled,
    'autopay-off': !isAutopayEnabled
  }"
>
  {{ 'ARC_PAYMENT_AUTOPAY_LABEL' | translate }}:
  {{
    isAutopayEnabled
      ? ('ARC_PAYMENT_AUTOPAY_ON_LABEL' | translate)
      : ('ARC_PAYMENT_AUTOPAY_OFF_LABEL' | translate)
  }}
</span>
